export async function logFrontendError(error, extra = {}) {
    try {
        await fetch("/log_client_error", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                message: error?.message ?? String(error),
                stack: error?.stack ?? null,
                page: window.location.href,
                userAgent: navigator.userAgent,
                timestamp: new Date().toISOString(),
                ...extra
            })
        });
    } catch (e) {
        console.error("Failed to log frontend error", e);
    }
}